<script lang="ts" context="module">
    export const name = "default";
</script>

<script lang="ts">
    import { z } from "zod";
    import Data from "@reperio-news/core.components/blocks/ContentList/Data";
    import ContentItem from "@reperio-news/core.components/blocks/ContentItem/View.svelte";
    type Data = z.infer<typeof Data>;
    export let data: Data;
    export let indexInContainer: number[];
    indexInContainer;
</script>

{#if data.content && data.content.items && data.content.items.length}
    {#each data.content.items as item, index}
        <ContentItem
            data={{
                content: item,
                layout: data.content_layout,
                custom_fields: data.content_custom_fields,
            }}
            indexInContainer={[index, data.content.items.length]}
        />
    {/each}
{/if}
